module.exports = __webpack_public_path__ + "assets/img/prepaid.53682106.png";